import { Controller } from "@hotwired/stimulus"

// Kiezen met knoppen in plaats van met een zoekveld. Een hovenier heeft een
// handvol opdrachtgevers; die hoort hij aan te tikken, niet in te typen.
// Het zoekveld blijft bestaan achter de knop "Zoeken", voor wie er veel heeft.
export default class extends Controller {
  static targets = ["knop", "zoeken"]

  connect() {
    this.filter()
  }

  kies(event) {
    const knop = event.currentTarget
    const waarde = knop.dataset.waarde
    const tekst = knop.dataset.tekst || knop.textContent.trim()

    const verborgen = document.getElementById(this.element.dataset.keuzeknoppenVeld)
    if (!verborgen) return

    verborgen.value = waarde

    // Eerst het zoekveld van dezelfde keuze bijwerken, dan pas het signaal: wie
    // meeluistert (de stappen) kijkt naar wat er in beeld staat, en zag anders
    // nog een leeg veld.
    const zichtbaar = document.getElementById(this.element.dataset.keuzeknoppenTekstveld)
    if (zichtbaar) zichtbaar.value = tekst

    verborgen.dispatchEvent(new Event("input", { bubbles: true }))
    verborgen.dispatchEvent(new Event("change", { bubbles: true }))

    this.knopTargets.forEach((andere) => andere.setAttribute("aria-pressed", andere === knop ? "true" : "false"))
  }

  // Vandaag of gisteren in één tik; de kalender blijft achter "Andere datum".
  datum(event) {
    const knop = event.currentTarget
    const veld = document.querySelector("input[type='date'][name*='[date]']")
    if (!veld) return

    veld.value = knop.dataset.datum
    veld.dispatchEvent(new Event("input", { bubbles: true }))
    veld.dispatchEvent(new Event("change", { bubbles: true }))
    this.knopTargets.forEach((andere) => andere.setAttribute("aria-pressed", andere === knop ? "true" : "false"))
  }

  // Knoppen die bij een andere keuze horen (projecten bij een opdrachtgever)
  // verdwijnen zodra die keuze verandert.
  filter() {
    const bron = document.getElementById(this.element.dataset.keuzeknoppenFilterveld)
    const waarde = bron?.value || ""
    const passend = this.knopTargets.filter((knop) => {
      const hoort = !bron || !knop.dataset.filter || knop.dataset.filter === waarde || knop.dataset.filter === "*"
      if (!hoort && knop.getAttribute("aria-pressed") === "true") knop.setAttribute("aria-pressed", "false")
      return hoort
    })
    this.beperk(passend)
  }

  // Hooguit een paar blobjes; de rest zit achter "Anders". Wat gekozen is, blijft
  // er altijd tussen staan, ook als het niet bij de beste drie hoort.
  beperk(passend) {
    const max = Number(this.element.dataset.keuzeknoppenMax) || passend.length
    const zichtbaar = passend.slice(0, max)
    const gekozen = passend.find((knop) => knop.getAttribute("aria-pressed") === "true")
    if (gekozen && !zichtbaar.includes(gekozen)) zichtbaar.splice(max - 1, 1, gekozen)
    this.knopTargets.forEach((knop) => { knop.hidden = !zichtbaar.includes(knop) })
  }

  // Een vaste werkdag in één tik: begintijd en eindtijd van het eerste tijdvak.
  tijd(event) {
    const knop = event.currentTarget
    const begin = document.querySelector("input[name$='[time_blocks_attributes][0][start_time]']")
    const eind = document.querySelector("input[name$='[time_blocks_attributes][0][end_time]']")
    if (!begin || !eind) return

    begin.value = knop.dataset.van
    eind.value = knop.dataset.tot
    this.toonHandmatig()
    ;[ begin, eind ].forEach((veld) => {
      veld.dispatchEvent(new Event("input", { bubbles: true }))
      veld.dispatchEvent(new Event("change", { bubbles: true }))
    })
    this.knopTargets.forEach((andere) => andere.setAttribute("aria-pressed", andere === knop ? "true" : "false"))
  }

  // De tijdvakken zelf staan pas in beeld als je ze nodig hebt: na een werkdag
  // (dan laten ze zien wat er is ingevuld) of na "Zelf invullen".
  toonHandmatig(focus = false) {
    const ids = (this.element.dataset.keuzeknoppenHandmatig || "").split(" ").filter(Boolean)
    const blokken = ids.map((id) => document.getElementById(id)).filter(Boolean)
    blokken.forEach((blok) => { blok.hidden = false })
    if (focus) blokken[0]?.querySelector("input:not([type=hidden])")?.focus()
  }

  // Tonen zonder de aandacht te pakken: "Tijdvak toevoegen" zet die zelf al op
  // het nieuwe tijdvak, en twee controllers die om de aandacht vechten geeft
  // een cursor die heen en weer springt.
  toon() {
    this.toonHandmatig(false)
  }

  zelf() {
    this.toonHandmatig(true)
    this.knopTargets.forEach((knop) => knop.setAttribute("aria-pressed", "false"))
  }

  // "Zoeken" haalt het gewone veld tevoorschijn; daarna blijft het staan.
  zoek() {
    this.zoekenTarget.hidden = false
    this.zoekenTarget.querySelector("input:not([type=hidden])")?.focus()
  }
}
